import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = props => /*#__PURE__*/_jsx("svg", {
  viewBox: "0 0 20 20",
  width: "1em",
  height: "1em",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    transform: "translate(2.1 2.5)",
    xmlns: "http://www.w3.org/2000/svg",
    d: "M0 7.64706H1.6V11.4706H14.4V7.64706H16V11.4706C16 12.3194 15.288 13 14.4 13H1.6C0.72 13 0 12.3194 0 11.4706V7.64706ZM8 9.94118L12.44 5.76588L11.304 4.68765L8.8 7.07353V0H7.2V7.07353L4.704 4.68765L3.568 5.77353L8 9.94118Z",
    fill: "currentColor"
  })
});
export default SvgDownload;